import { requests } from 'api';
import { getFirstSegment } from 'utils/urls';
import { Contract } from './types';

const apiBaseUrl = `/${getFirstSegment()}/api/contracts`;

export const ContractsApi = {
  find: (contractNumber: string, clientNumber: string) => requests.get<Contract>(`${apiBaseUrl}/find?contractNumber=${contractNumber}&clientNumber=${clientNumber}`)
};